import { BUSINESS_NAME } from "@/core/constants/business";

export const META = {
  title: `Reset Password | ${BUSINESS_NAME}`,
  meta_description:
    "Reset your password to access your Street Lawyer Services account. We'll send you a link to create a new password and regain access to your profile.",
  keywords:
    "forgot password, reset password, account recovery, Street Lawyer Services login help",
  canonicalUrl: "/forgot-password",
};

export const generateRichSnippet = () => {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: META.title,
    description: META.meta_description,
    url: `https://slsdispensary.com${META.canonicalUrl}`,
    mainEntity: {
      "@type": "WebPageElement",
      name: "Reset Password Form",
      potentialAction: {
        "@type": "ResetAction",
        target: {
          "@type": "EntryPoint",
          urlTemplate: "https://slsdispensary.com/forgot-password",
        },
      },
    },
  };
};
